// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9ae9ca0f","605":"fbc4ffc0","611":"c4586eee","619":"60a8d620","944":"e66cc8bf"}[chunkId] + ".chunk.js";
};